import React from "react";
import { Flex, Image } from "antd";
import logo from "../../../assets/logo-icon.svg";
import integration from "../../../assets/icons/integration.svg";
import nineoneapp from "../../../assets/brands/91app.svg";
import cyberbiz from "../../../assets/brands/cyberbiz.svg";
import shopify from "../../../assets/brands/shopify.svg";
import shopline from "../../../assets/brands/shopline.svg";

type BrandLinkProps = {
  brand: string;
};

export const BrandLink: React.FC<BrandLinkProps> = (props) => {
  const { brand } = props;

  const brandLogo = (brand: string) => {
    switch (brand) {
      case "cyberbiz":
        return <Image src={cyberbiz} preview={false} />;
      case "nineoneapp":
        return <Image src={nineoneapp} preview={false} />;
      case "shopify":
        return <Image src={shopify} preview={false} />;
      case "shopline":
        return <Image src={shopline} preview={false} />;
    }
  };

  return (
    <Flex
      style={{
        padding: "4px 40px 4px 40px",
      }}
      className="items-center"
    >
      <Image src={logo} preview={false} />
      <Image src={integration} preview={false} />
      {brandLogo(brand)}
    </Flex>
  );
};
